import webhooksConfiguration from '@/data/eventListenerWebhooks.json';

export default {
  configuration: webhooksConfiguration.fields,
}
